<template>
    <div class="create-page" @scroll.stop>
        <div class="modal-content">
            <img class="bg" src="@/assets/img/9-years/award-notice.png" alt="">
            <img class="modal-close" @click="closeModal" src="@/assets/img/9-years/modal-close.png" alt="">
            <div class="inner-text-wrapper">
                <div class="text">恭喜您获得道具礼包，</div>
                <div>兑换码：{{ prize.code }}</div>

                <div class="btn-wrapper">
                    <van-button size="normal" color="#7b6dc4" plain @click="handleCpy">复制</van-button>
                    <van-button size="normal" color="#7b6dc4" @click="closeModal">确定</van-button>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import { Button, Toast } from 'vant';
Vue.use(Button)
export default {
    name: 'AwardRecordModal',
    props: {
        prize: {
            default: () => ({}),
            type: Object
        }
    },
    data() {
        return {}
    },
    created() {
        document.body.style.overflow = 'hidden';
    },
    methods: {
        handleCpy() {
            // var inp = document.createElement('input');
            // document.body.appendChild(inp)
            // inp.value = this.prize.code
            // inp.select();
            // document.execCommand('copy', false);
            // inp.remove();
            // Toast("复制成功~")
            this.$copyText(this.prize.code).then(function () {
                Toast("复制成功~")
            }, function (e) {
                Toast('复制失败')
                console.log(e)
            })
        },
        closeModal() {
            document.body.style.overflow = '';
            this.$emit("closed")
        }
    }
}
</script>
<style scoped>
.create-page {
    position: fixed;
    width: 100vw;
    height: 100vh;
    max-width: 900px;
    left: 50%;
    top: 0px;
    z-index: 10;
    overflow-y: scroll;
    background-color: rgba(0, 0, 0, 0.65);
    transform: translateX(-50%);
}

.modal-content {
    position: absolute;
    top: 40%;
    left: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
}

.modal-content>.bg {
    width: 100%;
}

.inner-text-wrapper {
    position: absolute;
    box-sizing: border-box;
    width: 74%;
    height: 40%;
    top: 36%;
    left: 13%;
    color: #7b6dc4;
    font-size: 18px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
}

.inner-text-wrapper .text {
    padding: 10px;
}

.modal-close {
    width: 6%;
    position: absolute;
    right: 10px;
    top: 20px;
}

.btn-wrapper {
    position: absolute;
    bottom: 0;
    width: 65%;
    transform: translateX(-50%);
    left: 50%;
    display: flex;
    justify-content: space-around;
}
</style>>